import { render, staticRenderFns } from "./PaymentMethodPix.vue?vue&type=template&id=8d646408"
import script from "./PaymentMethodPix.vue?vue&type=script&lang=js"
export * from "./PaymentMethodPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports